<wms-dialog-header (onClose)="closeModal()" title='{{locale.LABEL_KEYBOARD_SHORTCUTS}}'></wms-dialog-header>
<wms-dialog-body>
    <div class="full-width full-height wm-shortcuts-container">
        <div class="col-md-6 types-container">
            <div class="content clearfix">
                <h5>{{locale.LABEL_GENERAL}}</h5>
                <p class="col-md-5">{{cmdTitle}} + S</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_S}}</p>

                <p class="col-md-5">{{cmdTitle}} + {{secondCmdTitle}} + Q</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_ALT_Q}}</p>

                <p class="col-md-5">{{cmdTitle}} + {{secondCmdTitle}} + R</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_ALT_R}}</p>

                <p class="col-md-5">{{cmdTitle}} + {{secondCmdTitle}} + P</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_ALT_P}}</p>
            </div>
            <div class="content clearfix">
                <h5>{{locale.LABEL_CODE_EDITOR}}</h5>
                <p class="col-md-5">{{cmdTitle}} + Space</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_SPACE}}</p>
            </div>
        </div>
        <div class="col-md-6 types-container">
            <div class="content clearfix">
                <h5>{{locale.LABEL_CANVAS}}</h5>
                <p class="col-md-5">Esc</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_ESC}}</p>

                <p class="col-md-5">Delete</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_DLT}}</p>

                <p class="col-md-5">{{cmdTitle}} + C</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_C}}</p>

                <p class="col-md-5">{{cmdTitle}} + V</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_V}}</p>

                <p class="col-md-5">{{cmdTitle}} + Z</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_Z}}</p>

                <p class="col-md-5">Shift + {{cmdTitle}} + Z</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_SHIFT_Z}}</p>
            </div>
            <div class="content clearfix">
                <h5>{{locale.LABEL_QUERY_EDITOR}}</h5>
                <p class="col-md-5">{{cmdTitle}} + Enter</p>
                <p class="col-md-7 help-text">{{locale.LABEL_KEYBOARD_CTRL_ENTER}}</p>
            </div>
        </div>
    </div>
</wms-dialog-body>
